// ── Faro (must be first, dev only) ──────────────────────
import { initializeFaro, getWebInstrumentations } from '@grafana/faro-web-sdk';

const faro = !import.meta.env.DEV ? initializeFaro({
  url: '/faro/collect',
  app: {
    name: 'kiplan-frontend',
    version: __APP_VERSION__ ?? '0.0.0',
    environment: window.__KIPLAN_ENV__ ?? 'unknown',
  },
  instrumentations: [
    ...getWebInstrumentations({
      captureConsole: true,
      captureConsoleDisabledLevels: ['debug', 'trace', 'log'],
    }),
  ],
}) : null;

// ── Everything else (unchanged) ─────────────────────────
import axios from 'axios'
import { createApp } from 'vue'
import App from './App.vue'
import router from '@/router.js'
import { Auth } from '@/database'
import store from './store';
import { createI18n } from 'vue-i18n'
import locales from './locales'
import './assets/global.css';
import '@quasar/extras/material-icons/material-icons.css'
import 'quasar/src/css/index.sass'
import { Quasar, Notify } from 'quasar'
import '@vue-flow/core/dist/style.css'
import metaRouter from './plugins/metaRouter'

axios.defaults.withCredentials = true
const _fetch = window.fetch.bind(window)
window.fetch = function fetchWithCreds(input, opts = {}) {
  return _fetch(input, { ...opts, credentials: 'include' })
}

const auth = new Auth()
const app = createApp(App).use(router)
app.use(store);

const urlParams = new URLSearchParams(window.location.search);
if (urlParams.has('token')) {
    sessionStorage.setItem('token', urlParams.get('token'));
}
if (urlParams.has('kiplan_api_url')) {
    sessionStorage.setItem('kiplan_api_url', urlParams.get('kiplan_api_url'));
}

const user = await auth.whoami()
if (user) {
    store.commit('setUser', user)
}

app.use(createI18n({
    locale: user.preferred_language || 'es',
    globalInjection: true,
    messages: locales
}))

// ── Wire Faro into Vue's error handler (dev only) ───────
if (faro) {
    app.config.errorHandler = (err, _instance, info) => {
        faro.api.pushError(err, { context: { componentInfo: info } });
    };
}

app.use(Quasar, {
  plugins: { Notify },
})
app.use(metaRouter, { router })
app.mount('#app')